// extracted by mini-css-extract-plugin
module.exports = {"videoWrapper":"ready-video_videoWrapper__enAJS","iframe":"ready-video_iframe__31759"};